<template>
  <el-card v-loading="loading">
    <!-- <el-row type="flex" class="row-bg" justify="center"> -->
    <div id="page-panel">
      <div class="customer-top-nav">
        <div class="title">
          <span>{{$t('reports.names.'+reportCode)}}</span><br>
        </div>
        <div class="controls no-print">
          <el-dropdown size="small" type="default" class="">
            <el-button type="primary" size="small">
              <i class="el-icon-download"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="downloadReport('csv')"><i class="mdi mdi-file-excel"/> CSV</el-dropdown-item>
              <el-dropdown-item @click.native="downloadReport('QUICKBOOKS', true)"><i class="mdi mdi-file-excel"/> Export Quickbooks</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
  				 <el-button type="primary" @click="openFilterDialog" size="small"><i class="mdi mdi-filter"></i> </el-button>
  			</div>
      </div>

      <p>
        <span class="fs-14 secondary-text">{{companyName}}</span><br>
        <span class="fs-14 secondary-text">{{currentFilterPeriod}}</span><br>
        <span class="fs-14 secondary-text" v-if="customerName!=null && customerName!='' && filters.customerId!=null">Client sélectionné : {{customerName}}</span>
        <span class="fs-14 secondary-text" v-else>Tous les clients</span><br>
        <span class="fs-14 secondary-text" v-if="statusCode!=null && statusCode.length>0">Statut(s) sélectionné(s) : <el-tag v-for="status in statusCode" :key="filters.code" size="mini" :type="getInvoiceTagType(status)" style="margin-left:10px;"> {{$t("credit_notes.statuses."+status.code)}}</el-tag></span>
        <span class="fs-14 secondary-text" v-else>Tous les  statuts</span>
      </p>
      <div id="printMe">
        <el-table :data="summary" style="width:100%" ref="summary" :cell-style="{padding:'4px'}" class="mb-60" v-loading="loadingSummary">
          <el-table-column  align="left" label="Sommaire">
            <template slot-scope="scope">
              <span class="fs-14" v-bind:class="{'secondary-text' : !scope.row.header, 'pl-30' : !scope.row.header}">{{$t('reports.CREDITS_DETAIL.headers.'+scope.row.name)}}</span>
            </template>
          </el-table-column>
          <el-table-column  align="right" >
            <template slot-scope="scope">
              <span class="fs-14" v-bind:class="{'secondary-text' : !scope.row.header}">{{scope.row.total}} $</span>
            </template>
          </el-table-column>
        </el-table>
        <div v-if="tooManyResults" class="text-center bg-warning-lighter p-20 fs-18">
          <i class="el-icon-warning-outline"> </i>
          <span> Il y a trop de facture pour les afficher à l'écran</span>
          <p>Veuillez télécharger le rapport en format <el-button type="text" @click="downloadReport('csv')">CSV</el-button></p>
        </div>
        <CreditsDetailCreditsView v-if="filters.groupBy=='CREDITS' && !loading && !tooManyResults" :credits="data" :filters="filters"></CreditsDetailCreditsView>
        <CreditsDetailCustomerView v-if="filters.groupBy=='CUSTOMER' && !loading && !tooManyResults" :customers="data" :filters="filters"></CreditsDetailCustomerView>

      </div>
    <reportFilter :visible="reportFilterVisible"
                  @close="closeFilterDialog"
                  :predefinedPeriod="predefinedPeriod"
                  :groups="groups"
                  :group="this.filters.groupBy"
                  :period="period"
                  :startDate="this.filters.startDate"
                  :endDate="this.filters.endDate"
                  :statusesCollection="creditNoteStatuses"
                  statusType='credit_notes.statuses'
                  :statuses="this.filters.statusId"
                  :customerFilter="true"
                  :customer="selectedCustomer"
                  :showReportLevel="true"
                  :detailed="filters.detailed"
                  @applyFilter="handleFilter">
    </reportFilter>
    <WatingDialog :visible="downloading" content="Veuillez patienter pendant que nous préparons votre rapport. Cela peut prendre plusieurs secondes."></WatingDialog>
</div>
<!-- </el-row> -->
</el-card>
</template>
<script>
//import Section
import creditNoteAPI from '@/services/API/creditNote.js'
import moment from 'moment'
import reportFilter from './report-filter'
import reportUtil from '@/utils/report-util.js'
import CreditsDetailCustomerView from './credits_detail_customer_view'
import CreditsDetailCreditsView from './credits_detail_credits_view'
import CustomerUtil from '@/utils/customer-util'
import WatingDialog from '@/components/waiting-dialog'
import { mapActions, mapState, mapGetters } from 'vuex';

export default {
  name : "report-credits",
  props : {
    width : {
      type : Number,
      default : 100
    },
    fiscalEndDay : Number,
    fiscalEndMonth : Number,
    lastFiscalYearDate : Object,
    fiscalYearDate : Object,
    month : Object,
    lastMonth : Object,
    companyName : '',

  },
  data() {
    return {
      loadingSummary: false,
      tooManyResults : false,
      output : null,
      data : [],
      summaryData : {},
      loading:true,
      statusCode : [],
      filters : {
        range : null,
        startDate : null,
        endDate : null,
        statusId : [],
        customerId : null,
        groupBy : 'CUSTOMER',
        detailed : true,
      },
      customerName : null,
      reportFilterVisible : false,
      pageWidth : null,
      pageHeight : null,
      downloading : false,
    };
  },
  components : {
    reportFilter,
    CreditsDetailCustomerView,
    CreditsDetailCreditsView,
    WatingDialog
  },
  computed : {
    selectedCustomer(){
      if(this.filters.customerId!=null && this.filters.customerId!=undefined){
        return {id:this.filters.customerId}
      }else{
        return null;
      }
    },
    tableWidth(){
      return 'width : ' + this.width + 'px;';
    },
    currentFilterPeriod(){
      return reportUtil.currentFilterPeriod(this.fiscalYearDate,this.lastFiscalYearDate,this.filters.range,this.filters.startDate,this.filters.endDate )
    },
    predefinedPeriod(){
      if(this.fiscalYearDate.startDate!=null && this.fiscalYearDate.endDate!=null){
        return [
          {code : 'MONTH', description:this.month.startDate.format('DD MMM YYYY') + '-'+this.month.endDate.format('DD MMM YYYY')},
          {code : 'LAST_MONTH', description:this.lastMonth.startDate.format('DD MMM YYYY') + '-'+this.lastMonth.endDate.format('DD MMM YYYY')},
          {code : 'FISCAL_YEAR',description:this.fiscalYearDate.startDate.format('DD MMM YYYY') + '-'+this.fiscalYearDate.endDate.format('DD MMM YYYY')},
          {code : 'LAST_FISCAL_YEAR',description:this.lastFiscalYearDate.startDate.format('DD MMM YYYY') + '-'+this.lastFiscalYearDate.endDate.format('DD MMM YYYY')},
          {code : 'CUSTOM', range:true}
        ]
      }else{
        return [];
      }

    },
    period(){
      return _.find(this.predefinedPeriod, p=>{return p.code==this.filters.range})
    },
    reportCode(){
      return this.$route.params.code;
    },
    total(){
      let total = 0.00;
      _.forEach(this.data, p=>{
        total+=p.amount;
      })
      return Math.round(total*100)/100;
    },
    summary(){
      let totalCreditEmited = this.summaryData.total
      let totalCreditUsed = this.summaryData.paid;
      let totalCreditLeft = this.summaryData.outstanding;
      let data = [
        {name:'total_credit_emited', header:false, total:totalCreditEmited},
        {name:'total_credit_paid', header:false, total:totalCreditUsed},
        {name:'totalCreditLeft', header:true, total:totalCreditLeft}
      ]
      return data;
      return [];
    },
    groups(){
      return ['CUSTOMER','CREDITS']
    },
    usableData(){
      return this.data;
    },
    ...mapState('statuses',['creditNoteStatuses']),
    ...mapGetters('invoices',['getInvoiceTagType'])

  },
  methods : {
    downloadReport(format){
      this.downloading=true;
      let filters = _.cloneDeep(this.filters);
      if(filters.startDate!=null){
        filters.startDate = moment(filters.startDate).format('YYYY-MM-DD');
      }
      if(filters.endDate!=null){
        filters.endDate = moment(filters.endDate).format('YYYY-MM-DD');
      }
      // console.log(filters);
      if(filters.customerId!=null){
        filters.customerName = localStorage.invoices_detail_customerName ? localStorage.invoices_detail_customerName : undefined;
      }

      filters.format=format

      let filename = 'CREDITS_REPORT_'+moment(this.filters.startDate).format('YYYY-MM-DD')+'-'+moment(this.filters.endDate).format('YYYY-MM-DD');
      filename+="."+format;
      if (format === 'QUICKBOOKS') {
        filters.statuses = filters.statusId;
        delete filters.credits_detail_statusId;
        return creditNoteAPI.downloadQuickbooksExtractCreditNotesCSV(filters, filename)
        .then(()=>{
          this.downloading=false;
        }).catch(err=>{
          this.downloading=false;
          this.$message.error("Oops... Une erreur est survenue!");
        })
      } else {
        return creditNoteAPI.downloadCreditsReport(this.reportCode, filename, filters)
        .then(()=>{
          this.downloading=false;
        }).catch(err=>{
          this.downloading=false;
          this.$message.error("Oops... Une erreur est survenue!");
        })
      }
      
    },
    getCustomerName(name, usual_name){
      return CustomerUtil.customerName(name, usual_name);
    },
    openCustomer(customerId){
      var index='/customers/'+customerId;
			this.$router.push(index);
    },
    _moment(date, format='l'){
      return moment(date).format(format);
    },
    handleFilter(filters){
      localStorage.credits_detail_detailed = filters.detailed;
      localStorage.credits_detail_groupBy=filters.group;
      localStorage.credits_detail_range=filters.period.code;
      localStorage.credits_detail_startDate = filters.dateRange[0];
      localStorage.credits_detail_endDate = filters.dateRange[1];
      localStorage.credits_detail_customerId = filters.customer!=null ? filters.customer.id : undefined;

      if(localStorage.credits_detail_statusId==null){
        localStorage.credits_detail_statusId=JSON.stringify([]);
      }

      this.filters.credits_detail_statusId=JSON.parse(localStorage.credits_detail_statusId);

      if(filters.customer!=null){
        localStorage.credits_detail_customerName = this.getCustomerName(filters.customer.name,filters.customer.usual_name);
      }else{
        delete localStorage.credits_detail_customerName;
      }
      let statuses = [];
      this.statusCode=[];
      _.forEach(filters.statuses, s=>{
        this.statusCode.push(s);
        statuses.push(s.id);
      })

      localStorage.credits_detail_statusId = JSON.stringify(statuses);

      this.setFilters();
      this.fetchSummaryData();
      this.fetchData();
    },
    openFilterDialog(){
      this.reportFilterVisible = true;
    },
    closeFilterDialog(){
      this.reportFilterVisible=false;
    },
    getRealPeriodNumber(falseNumber){
      let number = falseNumber;
      if(falseNumber>12){
        number-=12;
      }
      return number;
    },
    showPeriodName(periodNumber){
      if(this.filters.groupBy=='MONTH'){
        return moment().month(this.getRealPeriodNumber(periodNumber)).format('MMM');
      }else{
        let realPeriodNumber= this.getRealPeriodNumber(periodNumber);
        let startMonth = moment().month(((realPeriodNumber+1)*3)-3).format('MMM');
        let endMonth = moment().month(((realPeriodNumber+1)*3)-1).format('MMM');
        return startMonth + '-' + endMonth
      }

    },
    arraySpanMethod({ row, column, rowIndex, columnIndex }) {
        if(row.span){
          return {rowspan:1, colspan:this.nbColums+2}
        }else{
          return {rowspan:1, colspan:1}
        }
      },

		setPageWidth() {
			this.pageWidth = document.getElementById('page-panel').offsetWidth;
			this.pageHeight = document.getElementById('page-panel').offsetHeight;
		},
    __resizeHanlder: _.throttle(function (e) {
  			this.setPageWidth();
  		}, 700),
    fetchSummaryData(){
      this.loadingSummary = true;
      let filters = this.buildFilters();
      filters.summary=true;
      return creditNoteAPI.fetchAdminCreditNotes(filters)
        .then(result=>{

          this.summaryData = result.summary;
          this.loadingSummary = false;
        }).catch(err=>{
          console.log(err);
          this.loading = false;
          this.$message.error('Une erreur système est survenue. Veuillez réessayer plus tard')
        })
    },
    buildFilters(){
      let filters = _.cloneDeep(this.filters);
      if(filters.startDate!=null){
        filters.startDate = moment(filters.startDate).format('YYYY-MM-DD Z');
      }
      if(filters.endDate!=null){
        filters.endDate = moment(filters.endDate).format('YYYY-MM-DD Z');
      }
      filters.paging=false;
      return filters;
    },
    fetchData(){
      this.loading = true;
      let filters = this.buildFilters();
      return creditNoteAPI.fetchAdminCreditNotes(filters)
        .then(data=>{
          this.tooManyResults = (this.filters.detailed && data.length>100) || (!this.filters.detailed && data.length>1000) ? true : false;
          this.data = data;

          this.loading = false;
        }).catch(err=>{
          console.log(err);
          this.loading = false;
          this.$message.error('Une erreur système est survenue. Veuillez réessayer plus tard')
        })
    },
    setFilters(){

      if(localStorage.credits_detail_range==null){
        localStorage.credits_detail_range='MONTH';
      }
      this.customerName = localStorage.credits_detail_customerName;
      if(localStorage.credits_detail_groupBy==null){
        localStorage.credits_detail_groupBy='CUSTOMER';
      }
      this.filters.detailed = localStorage.credits_detail_detailed==null || localStorage.credits_detail_detailed=='false' ? false : true;
      this.filters.groupBy = localStorage.credits_detail_groupBy;
      this.filters.range=localStorage.credits_detail_range;
      // console.log("localStorage.payments_customerId : ", localStorage.payments_customerId);
      this.filters.customerId=localStorage.credits_detail_customerId!='undefined' && localStorage.credits_detail_customerId!=null  ? parseInt(localStorage.credits_detail_customerId) : undefined;

      this.filters.statusId=localStorage.credits_detail_statusId!=null?JSON.parse(localStorage.credits_detail_statusId):[];

      if(this.filters.range=='FISCAL_YEAR' && this.fiscalYearDate.startDate!=null && this.fiscalYearDate.endDate!=null){
        localStorage.credits_detail_startDate = this.fiscalYearDate.startDate;
        localStorage.credits_detail_endDate = this.fiscalYearDate.endDate;
      }else if(this.filters.range=='LAST_FISCAL_YEAR' && this.lastFiscalYearDate.startDate!=null && this.lastFiscalYearDate.endDate!=null){
        localStorage.credits_detail_startDate = this.lastFiscalYearDate.startDate;
        localStorage.credits_detail_endDate = this.lastFiscalYearDate.endDate;
      }else if(this.filters.range=='MONTH'){
        localStorage.credits_detail_startDate = this.month.startDate;
        localStorage.credits_detail_endDate = this.month.endDate;
      }else if(this.filters.range=='LAST_MONTH'){
        localStorage.credits_detail_startDate = this.lastMonth.startDate;
        localStorage.credits_detail_endDate = this.lastMonth.endDate;
      }

      this.filters.startDate = localStorage.credits_detail_startDate;
      this.filters.endDate = localStorage.credits_detail_endDate;
    },
    ...mapActions('statuses',['fetchCreditStatuses']),

  },
  mounted(){
    this.setPageWidth();
    this.$refs.summary.$options._parentVnode.elm.classList.remove('el-table--enable-row-hover')
  },
  beforeDestroy(){
    this.data = [];
  },
  created(){
    this.loading = true;
    this.setFilters();
    this.fetchCreditStatuses();
    this.fetchSummaryData();
    this.fetchData();
  }
}
</script>
<style lang="scss" scoped>
@import '../../../../../assets/scss/_variables';

@media print {
  body, html { margin-top:0%;
    font-size:0.8em;
     display:block;
     height:100%;
     width:100%;
     position:unset !important;
     background:none;
     overflow-x: hidden;overflow-y: auto;height:100%;width:100%;display:block;position:unset
   }
   .no-print{
   	display:none;
   }
   .el-card{
     border:none;
     width:100%;
   }

   @page {
     size: portrait;
   }


}
.title {
	font-size : 1.6em;
	font-weight:bold;
	margin-right:20px;
	position:relative;
	float:left;
}
.customer-top-nav{
  height:40px;
}

.controls{
	position:relative;
	float:right;

	button{
		margin-left:20px;
	}
}


</style>
